import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './services/queryClient';
import ErrorBoundary from './components/ErrorBoundary';
import { ErrorProvider, LoadingProvider } from './providers';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/Header';
import LoginForm from './components/LoginForm';
import HomePage from './pages/HomePage';
import MoviesPage from './pages/MoviesPage';
import TVShowsPage from './pages/TVShowsPage';
import SearchPage from './pages/SearchPage';
import PlayerPage from './pages/PlayerPage';
import PersonDetailsPage from './pages/PersonDetailsPage';
import './index.css';

const AuthenticatedApp: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginForm onLoginSuccess={() => window.location.reload()} />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-900">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/movies" element={<MoviesPage />} />
            <Route path="/shows" element={<TVShowsPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/movies/:id" element={<PlayerPage />} />
            <Route path="/shows/:id" element={<PlayerPage />} />
            <Route path="/player/:id" element={<PlayerPage />} /> {/* Keep for backward compatibility */}
            <Route path="/person/:id" element={<PersonDetailsPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <ErrorProvider>
        <LoadingProvider>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <AuthenticatedApp />
            </QueryClientProvider>
          </AuthProvider>
        </LoadingProvider>
      </ErrorProvider>
    </ErrorBoundary>
  );
};

export default App;